import React from 'react';
import AuthContext from './AuthContext';

export default function useAuth() {
  const auth = React.useContext(AuthContext);
  return auth;
}
